import { ProtectedRoute as SharedProtectedRoute } from '@mdvip/shared/system/ProtectedRoute';
import type { Action, Subject } from '@mdvip/shared/types/ability';
import type { ReactNode } from 'react';

import { useAuth } from '@/contexts/AuthContext';

interface ProtectedRouteProps {
  children: ReactNode;
  /** Ability the route requires. A failed check redirects to the dashboard. */
  can?: [Action, Subject];
}

export function ProtectedRoute({ children, can }: ProtectedRouteProps) {
  const { isAuthenticated, isLoading } = useAuth();
  return (
    <SharedProtectedRoute isAuthenticated={isAuthenticated} isLoading={isLoading} can={can} portalType="members">
      {children}
    </SharedProtectedRoute>
  );
}
